// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3El3y","row":"Node_row__3Bmus","label":"Node_label__3bmRa","footer":"Node_footer__3Dtbq"};